export enum SCHEDULES_LIMITS {
  MaxScheduleCount = 3,
}
